import SousChefSDK from 'souschef-sdk'
import { initFirebase, initFirestore, signIn, signOut } from '../services/FirebaseService'

const Backend = {
  state: {
    souschef: null,
    user: {},
    users: [],
    operators: [],
    organizations: []
  },
  mutations: {
    setUser (state, { user }) {
      state.user = user
      global.helper.ls.set('user', user)
    },
    setSousChefAPI (state, { souschef }) {
      state.souschef = souschef
    },
    signOut (state) {
      state.user = {}
      global.helper.ls.set('user', state.user)
      signOut()
    },
    setOrganizations (state, { organizations }) {
      state.organizations = organizations
    },
    addOrganization (state, { organization }) {
      state.organizations.push(organization)
    },
    setUsers (state, { users }) {
      state.users = users
    },
    setOperators (state, { operators }) {
      state.operators = operators
    },
    updateOrganization (state, { organization }) {
      state.organizations.filter(o => o.name === organization.name).forEach(o => { o.sheets = organization.sheets })
    },
    updateOrganizationFromSignedInUser (state, { user }) {
      state.user.organizationName = user.organizationName
    },
    updateOrganizationFromOperator (state, { user }) {
      state.operators.filter(o => o.email === user.email)[0].organizationName = user.organizationName
    },
    addOperator (state, { operator }) {
      state.operators.push(operator)
    },
    deleteOperator (state, { operator }) {
      for (let i = 0; i < state.operators.length; i++) {
        if (state.operators[i].email === operator.email) {
          state.operators.splice(i, 1)
        }
      }
    }
  },
  actions: {
    async initBackend ({ commit, state, dispatch }) {
      initFirebase()
      commit('setSousChefAPI', { souschef: new SousChefSDK(initFirestore()) })
      let user = global.helper.ls.get('user')
      if (user && user.uid) {
        commit('setUser', { user })
        if (!(await state.souschef.users.isSousChefAdmin(user))) {
          return commit('signOut')
        }
        return dispatch('getLatestUser', user)
      }
    },
    async getLatestUser ({ state, commit, dispatch }, userToUpdate) {
      let user = await state.souschef.users.getUser(userToUpdate.email)
      state.organizations.filter(org => org.id === user.organization)
        .forEach(org => { user.organizationName = org.name })
      commit('setUser', { user })
    },
    async signInWithGoogle ({ state, commit, dispatch }) {
      let user = await signIn()
      let isSousChefAdmin = await state.souschef.users.isSousChefAdmin(user)
      if (await state.souschef.users.isSousChefAdmin(user)) {
        dispatch('getLatestUser', user)
      }
      return isSousChefAdmin
    },
    async getOrganizations ({ commit, state, dispatch }) {
      let organizations = await state.souschef.organizations.getOrganizations()
      let user = state.user
      state.organizations.filter(org => org.id === user.organization)
        .forEach(org => { user.organizationName = org.name })
      commit('setUser', { user })
      commit('setOrganizations', { organizations })
    },
    async getUsers ({ commit, state, dispatch }) {
      let users = await state.souschef.users.getUsers()
      commit('setUsers', { users })
    },
    async getOperators ({ commit, state, dispatch }) {
      let operators = await state.souschef.users.getSousChefOps()
      operators.forEach(o => {
        state.users.filter(u => u.email === o.email)
          .forEach(u => { o.organization = u.organization })
        state.organizations.filter(org => org.id === o.organization)
          .forEach(org => { o.organizationName = org.name })
      })
      commit('setOperators', { operators })
    },
    async createOrganization ({ commit, state, dispatch }, organization) {
      let id = await state.souschef.createOrganization(organization)
      organization.id = id
      commit('addOrganization', { organization })
    },
    async updateOrganization ({ commit, state, dispatch }, organization) {
      await state.souschef.organizations.updateOrganization(organization)
      commit('updateOrganization', { organization })
    },
    async updateOrganizationFromSignedInUser ({ commit, state, dispatch }, user) {
      await state.souschef.users.addUser(user)
      commit('updateOrganizationFromSignedInUser', { user })
    },
    async updateOrganizationFromOperator ({ commit, state, dispatch }, user) {
      await state.souschef.users.addUser(user)
      commit('updateOrganizationFromOperator', { user })
    },
    async addOperator ({ commit, state, dispatch }, operator) {
      await state.souschef.users.addSousChefOperator(operator)
      commit('addOperator', { operator })
    },
    async deleteOperator ({ commit, state, dispatch }, operator) {
      await state.souschef.users.deleteSousChefOperator(operator)
      commit('deleteOperator', { operator })
    }
  }
}

export default Backend
